/*!

=========================================================
* Paper Dashboard PRO React - v1.3.1
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { installPromiseWithResolversPolyfill } from "utils/promiseWithResolversPolyfill";
import { installUrlParsePolyfill } from "utils/urlParsePolyfill";
import { ensureCoreUiFontsLoaded } from "config/appFonts";
import React from "react";
import ReactDOM from "react-dom/client";
import { Router } from "react-router-dom";
import { Provider } from "react-redux";
import { initSentry } from "config/sentryClient";
import { routerHistory } from "./routerHistory";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.1";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "assets/css/global.css";
import App from "App";
import MetaPixelTracker from "components/MetaPixelTracker";
import MetaPremiumTracker from "components/MetaPremiumTracker";
import PublicPageSeo from "components/PublicPageSeo";
import StructuredData from "components/StructuredData";
import store from "app/store";

// Install newer web APIs required by pdf.js before its lazy chunk loads.
installPromiseWithResolversPolyfill();
installUrlParsePolyfill();
initSentry();
ensureCoreUiFontsLoaded();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <Router history={routerHistory}>
      <PublicPageSeo />
      <StructuredData />
      <MetaPixelTracker />
      <MetaPremiumTracker />
      <App />
    </Router>
  </Provider>
);
